<script setup>
import { useI18n } from 'vue-i18n';

defineProps({
  modelValue: {
    type: String,
    default: '7d',
  },
});

const emit = defineEmits(['update:modelValue']);

const { t } = useI18n();

const RANGES = ['today', '7d', '30d'];

const labelFor = range => t(`VINCTO_HOME.RANGE.${range.toUpperCase()}`);
</script>

<template>
  <div
    class="flex items-center gap-0.5 p-[3px] rounded-[10px] bg-n-alpha-2 dark:bg-n-solid-1"
  >
    <button
      v-for="range in RANGES"
      :key="range"
      type="button"
      class="px-3 py-1 text-xs font-semibold rounded-lg transition-colors"
      :class="
        modelValue === range
          ? 'bg-white dark:bg-n-solid-3 text-n-slate-12 shadow-sm'
          : 'text-n-slate-10 hover:text-n-slate-12'
      "
      @click="emit('update:modelValue', range)"
    >
      {{ labelFor(range) }}
    </button>
  </div>
</template>
